module.exports = __webpack_public_path__ + "static/media/POLD.bcd00088.png";